<div class="d-flex flex-row flex-nowrap group-item" *ngIf="influencerGroup">
  <div class="d-flex flex-row flex-auto full-width">
    <div class="group-content-wrapper d-flex" [ngClass]="{'open': showGroupSetting === true}">
      <div class="influencer-info d-flex align-items-center">
        <div class="d-flex flex-auto full-width">
          <a (click)="openGroupDetails(activeAccount)"
             class="d-flex flex-row flex-auto not-underline details-link flex-nowrap full-width">
            <div class="d-flex flex-row group-overview-block full-width">
              <div  class="d-flex flex-column justify-content-center align-items-center group-details-icon-wrapper">
                <img src="/assets/images/Details_Icon.svg" class="details-icon-group"/>
              </div>
              <div class="d-flex ellipsis">
                <span class="group-info-loader" *ngIf="isUpdatingGroupInfo">
                  <achoo-loader [textPlaceholder]="true"></achoo-loader>
                </span>
                <div class="group-group-info d-flex flex-column justify-content-center full-width" *ngIf="!isUpdatingGroupInfo">
                  <div class="group-name">
                    {{influencerGroup.name}}
                  </div>
                  <div class="group-type">
                    {{influencerGroup.description || 'group_influencers.no-description' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column justify-content-center group-follower-block ellipsis">
              <div class="group-follower"></div>
            </div>
          </a>
        </div>
        <div *ngIf="showTotalPendingInfluencer" class="total-peding-influencer">{{'group_influencers.total_pending_influencer' | translate:{totalPendingInfluencers: influencerGroup.totalPendingInfluencers} }}</div>
      </div>
      <div class="influencer-kpi-block d-flex flex-row">
        <div class="d-flex flex-row flex-nowrap flex-auto align-items-center">
          <div class="influencer-avatar-list d-flex flex-row align-items-center group-images flex-nowrap">
            <div class="d-flex flex-row flex-nowrap align-items-center">
              <div class="left-seperate-line"></div>
              <span class="loader" *ngIf="showLoader">
                <achoo-loader [groupPlaceholder]="true"></achoo-loader>
              </span>
              <div class="no-padding number-remaining-influencer" *ngIf="!showLoader">
                <span *ngIf="numberRemaingInfluencer > 0" class="total-influencers">+{{normalizeNumberData(numberRemaingInfluencer)}}</span>
              </div>
              <div *ngIf="!showLoader" class="d-flex flex-row flex-wrap align-items-center justify-content-start list-images influencer-id-{{influencerGroup.id}}">
                <div *ngFor="let influencer of influencerGroup.influencers" class="display-image">
                  <achoo-user-avatar
                    [showCountryFlagIcon]="false"
                    [userAvatarPicture]="influencer.profilePicture"
                    [avatarHeight]="3.3125"
                    [avatarWidth]="3.3125">
                  </achoo-user-avatar>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!isRecentlyVisitedInfluencerGroup" class="d-flex flex-column justify-content-center ellipsis engagement-kpi-block">
            <div class="d-flex flex-row flex-nowrap align-items-center">
              <div class="left-seperate-line reach-block"></div>
              <span class="group-content text-light-font ellipsis">{{normalizeNumberData(influencerGroup.totalReach)}}</span>
            </div>
          </div>
          <div *ngIf="!isRecentlyVisitedInfluencerGroup" class="d-flex flex-column justify-content-center ellipsis reach-kpi-block">
            <div class="d-flex flex-row flex-nowrap align-items-center">
              <div class="left-seperate-line engagement-block"></div>
              <span class="group-content text-light-font ellipsis">{{normalizeNumberData(influencerGroup.totalEngagement)}}</span>
            </div>
          </div>
          <div *ngIf="!isRecentlyVisitedInfluencerGroup" class="d-flex flex-row align-items-center justify-content-center group-action-button-block">
            <div class="d-flex flex-row flex-auto action-group">
              <div class="left-seperate-line"></div>
              <div class="button-icon icon-add">
                <a class="icon-add"
                   actionByLevels="Add influencer to group"
                   [wallName]="'Groups Disabled'"
                   [actionData]="invalidActionData('add influencer')"
                   (afterChecking)="executeAddInfluencerGroup()"
                   placement="bottom"
                   ngbTooltip="{{'info_box.influencer_group.add_infl' | translate}}"></a>
              </div>
              <div class="button-icon icon-delete">
                <a class="icon-delete"
                   actionByLevels="Delete Group"
                   [wallName]="'Groups Disabled'"
                   [actionData]="invalidActionData('delete')"
                   (afterChecking)="executeDeleteInfluencerGroup()"
                   placement="bottom"
                   ngbTooltip="{{'info_box.influencer_group.delete_group' | translate}}"></a>
              </div>
              <div class="button-icon icon-config">
                <a class="icon-edit"
                   actionByLevels="Auto update groups"
                   [wallName]="'Advanced Groups'"
                   [actionData]="invalidActionData('update config')"
                   (afterChecking)="executeEditInfluencerGroup()"
                   placement="bottom-right"
                   ngbTooltip="{{'info_box.influencer_group.config' | translate}}"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row influencer-group-setting" [ngClass]="{'collapsed': showGroupSetting === false}" *ngIf="!isRecentlyVisitedInfluencerGroup">
  <div class="col-md-12 col-sm-12">
    <new-group-settings *ngIf="openNewGroupSetting" #newGroupSetting
                        [influencerGroup]="influencerGroupData"
                        [listProject]="listProjectOfAdvertiser"
                        (updateGroupEvent)="updateGroupEvent($event)"
                        (editOrCreateProjectEvent)="editOrCreateProject($event)"
                        (beforeSubmitGroupSetting)="beforeSubmitGroupSetting()"
                        (afterSubmitGroupSetting)="afterSubmitGroupSetting($event)">
    </new-group-settings>
  </div>
</div>
<achoo-popup #SaveGroupSettingError
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}">
  <span>{{'new_group_settings.save_group_setting_failed' | translate}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/influencer-groups/group-item/group-item.component.html